'use client'

import { useAtomValue, useSetAtom } from 'jotai'
import { ChevronLeft, Radio } from 'lucide-react'

import { cn } from '@/lib/utils'
import {
  floatingActivityRailItemsAtom,
  removeFloatingActivityRailItemAtom,
} from '@/state/floating-activity'

export function FloatingActivityRail() {
  const items = useAtomValue(floatingActivityRailItemsAtom)
  const restoreItem = useSetAtom(removeFloatingActivityRailItemAtom)

  if (items.length === 0) return null

  return (
    <nav
      aria-label="Minimized activities"
      className="fixed top-1/2 right-0 z-50 flex max-h-[calc(100dvh-6rem)] -translate-y-1/2 flex-col items-end gap-2 overflow-y-auto py-1"
    >
      {items.map((item) => {
        const warning = item.tone === 'warning'
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => restoreItem(item.id)}
            title={item.label}
            aria-label={`Restore ${item.label}`}
            className={cn(
              'bg-card border-foreground/10 flex min-h-16 cursor-pointer flex-col items-center gap-1.5',
              'rounded-l-none border border-r-0 px-2 py-3 shadow-xl backdrop-blur-xl',
              'hover:bg-white/5'
            )}
          >
            <ChevronLeft className="text-foreground/40 size-3.5" />
            <Radio className={cn('size-3.5', warning ? 'text-chart-red' : 'text-foreground')} />
            <span
              className={cn(
                'text-[10px] font-semibold tracking-tight [writing-mode:vertical-rl]',
                warning ? 'text-chart-red' : 'text-foreground'
              )}
            >
              {item.label}
            </span>
            {item.count !== undefined && (
              <span
                className={cn(
                  'text-[10px] font-semibold',
                  warning ? 'text-ox-gold' : 'text-foreground'
                )}
              >
                {item.count}
              </span>
            )}
          </button>
        )
      })}
    </nav>
  )
}
